import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'read-more',
    template: `
        <div [class.collapsed]="isCollapsed">
            <ng-content></ng-content>
            <a (click)="isCollapsed =! isCollapsed" class="text-green">{{ isCollapsed ? '^':'...'}}</a>
        </div>
    `,
    styles: [`
        div.collapsed {
            height: 250px;
            overflow-y: auto;
            white-space: pre-line;
        }
    `]
})

export class ReadMoreComponent {
    isCollapsed: boolean = true;
}


// WEBPACK FOOTER //
// ./src/directives/read-more.ts